import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const markdownRoot = '[data-variant="layout.common.markdown"]';

const markdownContent: ThemeUICSSObject = {
  color: 'inherit',
  fontFamily: 'body',
  lineHeight: 1.45,
  maxWidth: '100%',
  minWidth: 0,
  overflowWrap: 'anywhere',
  p: 0,
  wordBreak: 'normal',

  '& > :first-child': {
    mt: 0,
  },

  '& > :last-child': {
    mb: 0,
  },

  'h1, h2, h3, h4, h5, h6': {
    borderBottom: 'none',
    color: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: 1.3,
    m: 0,
    mb: '14px',
    mt: '30px',
    pb: 0,
    textDecoration: 'none',

    '& *': {
      fontFamily: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
  },

  '& > h1, & > h2, & > h3, & > h4, & > h5, & > h6': {
    mb: '14px',
    mt: '30px',
  },

  '& > h1:first-child, & > h2:first-child, & > h3:first-child, & > h4:first-child, & > h5:first-child, & > h6:first-child':
    {
      mt: 0,
    },

  h1: {
    fontSize: '1.22rem',
  },

  h2: {
    fontSize: '1.14rem',
  },

  h3: {
    fontSize: '1.06rem',
  },

  'h4, h5, h6': {
    fontSize: '1rem',
  },

  '& > p, & > ul, & > ol, & > blockquote, & > pre, & > table, & > hr': {
    mb: '12px',
    mt: 0,
  },

  '& > ul + p, & > ol + p, & > ul + h1, & > ul + h2, & > ul + h3, & > ul + h4, & > ul + h5, & > ul + h6, & > ol + h1, & > ol + h2, & > ol + h3, & > ol + h4, & > ol + h5, & > ol + h6':
    {
      mt: '32px',
    },

  '& > p + ul, & > p + ol': {
    mt: '6px',
  },

  '& p': {
    minWidth: 0,
  },

  'p + p': {
    mt: '10px',
  },

  'ul, ol': {
    listStylePosition: 'outside',
    m: 0,
    pb: 0,
    pl: '1.45em',
  },

  'ol + ul, ul + ul, ol + ol, ul + ol': {
    mt: 2,
    pl: '1.45em',
  },

  'ol ul, ul ul, ol ol, ul ol': {
    mb: 0,
    mt: 1,
    pb: 0,
    pl: '1.45em',
  },

  li: {
    m: 0,
    pl: '0.15em',
  },

  'li + li': {
    mt: 1,
  },

  'li > p': {
    m: 0,
  },

  'li > p + p': {
    mt: 1,
  },

  blockquote: {
    borderLeft: '3px solid',
    borderLeftColor: 'palette.border.article',
    fontStyle: 'normal',
    m: 0,
    mb: 2,
    pl: 3,
  },

  code: {
    fontFamily: 'monospace',
    fontSize: '0.92em',
  },

  'p code, li code, td code, th code, blockquote code': {
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    border: '1px solid',
    borderColor: 'palette.border.article',
    borderRadius: '3px',
    px: 1,
    py: '1px',
  },

  pre: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    border: '1px solid',
    borderColor: 'palette.border.article',
    borderRadius: '4px',
    boxSizing: 'border-box',
    maxWidth: '100%',
    overflowX: 'hidden',
    overflowWrap: 'anywhere',
    p: 3,
    tabSize: 2,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },

  'pre code': {
    background: 'transparent',
    border: 'none',
    color: 'inherit',
    display: 'block',
    fontSize: '0.92em',
    lineHeight: 1.45,
    overflowWrap: 'inherit',
    p: 0,
    whiteSpace: 'inherit',
    wordBreak: 'inherit',
  },

  a: {
    color: 'inherit',
    overflowWrap: 'anywhere',
    textDecoration: 'underline',
  },

  img: {
    display: 'block',
    height: 'auto',
    maxWidth: '100%',
  },

  table: {
    display: 'block',
    maxWidth: '100%',
    overflowX: 'auto',
    whiteSpace: 'normal',
  },

  'th, td': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },

  hr: {
    border: 0,
    borderTop: '1px solid',
    borderTopColor: 'palette.border.article',
  },
};

export const history: ThemeUICSSObject = {
  /* PREPEND HERE */

  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 0,
  p: 3,

  '.chatHistoryVirtualItem': {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    pb: 2,
    width: '100%',
  },

  '.chatHistoryVirtualFooter': {
    flex: '0 0 auto',
    pointerEvents: 'none',
  },

  '.history_message__content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '100%',
    minWidth: 0,

    [markdownRoot]: markdownContent,

    '.message__body.markdown': {
      maxWidth: '100%',
      minWidth: 0,

      [markdownRoot]: markdownContent,
    },
  },

  '.history_message': {
    boxSizing: 'border-box',
    m: 0,
    minWidth: '50px',
    overflowWrap: 'break-word',
    px: 4,
    py: 3,
    borderRadius: 'chatMessage',
    maxWidth: 'min(100%, calc(100% - 50px))',
    whiteSpace: 'normal',
    width: 'fit-content',
    wordBreak: 'normal',

    '&.last': {
      mb: 4,
    },
    '&.user': {
      '&.first': {
        borderTopRightRadius: '0px',
      },

      '&.first:has(+ .first)': {
        mb: 4,
      },
      backgroundColor: 'rgb(108 166 203)', // TODO: Set the correct color, if necessary, define it in palette
      color: 'white', // TODO: Set the correct color, if necessary, define it in palette
      '.fileCard__content': {
        color: 'palette.text.primary',
      },
      [markdownRoot]: {
        'pre, p code, li code, td code, th code, blockquote code': {
          backgroundColor: 'rgba(255, 255, 255, 0.18)',
          borderColor: 'rgba(255, 255, 255, 0.28)',
        },

        blockquote: {
          borderLeftColor: 'rgba(255, 255, 255, 0.45)',
        },
      },
      border: '1px solid rgb(113 145 193)', // TODO: Set the correct color, if necessary, define it in palette
      alignSelf: 'end',
      display: 'flex',
      flexDirection: 'column',
    },

    '&.system': {
      '&.first': {
        borderTopLeftRadius: '0px',
      },

      '&.first:has(+ .first)': {
        mb: 4,
      },
      backgroundColor: '#00bcff14', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.warning': {
      borderRadius: 'chatMessage',
      borderTopLeftRadius: '0px',
      alignSelf: 'start',
      backgroundColor: '#ffff0024', // TODO: Set the correct color, if necessary, define it in palette
      maxWidth: '100%',
      width: '100%',
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.error': {
      borderRadius: 'chatMessage',
      borderTopLeftRadius: '0px',
      alignSelf: 'start',
      backgroundColor: '#fd84212b', // TODO: Set the correct color, if necessary, define it in palette
      maxWidth: '100%',
      width: '100%',
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.information': {
      borderRadius: 'chatMessage',
      borderTopLeftRadius: '0px',
      alignSelf: 'start',
      backgroundColor: '#00bcff14', //'#2222cc2b',
      maxWidth: '100%',
      width: '100%',
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.customMessage:has(.chatAssistantStackSegment), &.customMessage:has(.chatAssistantTurn)':
      {
        alignSelf: 'stretch',
        background: 'transparent',
        border: 'none',
        borderRadius: 0,
        maxWidth: '100%',
        minWidth: 0,
        p: 0,
        whiteSpace: 'normal',
        width: '100%',

        '.history_message__content': {
          display: 'block',
          gap: 0,
          width: '100%',
        },
      },
  },

  '.chatAssistantTurn': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '100%',
    minWidth: 0,
    width: '100%',
  },

  '.chatAssistantStackSegment': {
    maxWidth: '100%',
    minWidth: 0,
    width: '100%',
  },

  '.chatAssistantSegment': {
    maxWidth: '100%',
    minWidth: 0,
    overflowWrap: 'anywhere',
    whiteSpace: 'normal',
  },

  '.chatAssistantStackSegment--text .chatAssistantSegment': {
    background: '#fbfcfe',
    border: '1px solid',
    borderColor: '#dbe2ea',
    borderRadius: '6px',
    color: 'palette.text.primary',
    px: 3,
    py: 2,
  },

  '.chatAssistantStackSegment--block .chatAssistantSegment': {
    background: '#f5f5f5',
    border: '1px solid',
    borderColor: '#ccc',
    borderRadius: '4px',
    color: '#7a7a7a',
    fontSize: '12px',
    lineHeight: '16px',
    px: 2,
    py: 1,
    whiteSpace: 'pre-wrap',
  },

  '.chatAssistantSegment--block': {
    color: 'inherit',
    fontSize: '12px',
    lineHeight: '16px',
    whiteSpace: 'pre-wrap',
  },

  '.chatAssistantSegment__response': {
    borderTop: '1px solid',
    borderTopColor: 'palette.border.field',
    color: 'palette.text.primary',
    mt: 2,
    pt: 2,
    whiteSpace: 'normal',
  },

  '.chatAssistantPanel': {
    background: '#fff',
    border: '1px solid',
    borderColor: 'palette.border.article',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    overflow: 'hidden',
  },

  '.chatAssistantPanel__toggle': {
    alignItems: 'center',
    background: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    font: 'inherit',
    gap: 2,
    justifyContent: 'space-between',
    minHeight: '30px',
    minWidth: 0,
    px: 3,
    py: 2,
    textAlign: 'left',
    width: '100%',

    '&:hover': {
      background: 'palette.background.default',
    },

    '&[aria-expanded="true"]': {
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.field',
    },
  },

  '.chatAssistantPanel__copy': {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    gap: 1,
    minWidth: 0,
  },

  '.chatAssistantPanel__title': {
    color: 'palette.text.primary',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '14px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '.chatAssistantPanel__meta': {
    alignItems: 'center',
    color: 'palette.text.disabled',
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: '10px',
    gap: 1,
    lineHeight: '13px',
  },

  '.chatAssistantPanel__metaItem': {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '.chatAssistantPanel__chevron': {
    color: 'palette.text.disabled',
    flex: '0 0 auto',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: '13px',
    transition: 'transform 160ms ease',
  },

  '.chatAssistantPanel__toggle[aria-expanded="true"] .chatAssistantPanel__chevron':
    {
      transform: 'rotate(180deg)',
    },

  '.chatAssistantPanel__bodyClip': {
    maxHeight: 0,
    opacity: 0,
    overflow: 'hidden',
    transform: 'translateY(-4px)',
    transition:
      'max-height 180ms ease, opacity 140ms ease, transform 180ms ease',
    willChange: 'max-height, opacity, transform',
  },

  '.chatAssistantPanel__bodyClip--expanded': {
    maxHeight: '220px',
    opacity: 1,
    transform: 'translateY(0)',
  },

  '.chatAssistantPanel__bodyClip--collapsed': {
    maxHeight: 0,
    opacity: 0,
    transform: 'translateY(-4px)',
  },

  '.chatAssistantPanel__body': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxHeight: '180px',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    p: 2,
  },

  '.chatAssistantPanel__item': {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    px: 2,
    py: 1,
  },

  '.history_message__attachments': {
    display: 'flex',
    justifyContent: 'flex-end',

    '.labelBox': {
      width: 'max-content',
      background: '#fafafa',
      color: 'palette.text.primary',
      fontSize: '14px',
      '.labelAndIcon ': {
        fontSize: '14px',
      },
    },
  },
};
